import React from "react";
import {withStyles} from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import i18n from '../i18n';

const Error = ({classes, error, onHomeClick, onReportClick}) => (
    <React.Fragment>
        <CssBaseline/>
        <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.layout}
        >
            <Grid item>
                <div className={classes.container}>
                    <Icon className={classes.icon}>
                        error
                    </Icon>

                    <div>
                        <Typography variant="h3">
                            {i18n.get('default.error.title')}
                        </Typography>

                        <Typography variant="h4">
                            {i18n.get('default.error.subtitle')}
                        </Typography>
                    </div>
                </div>

                <Divider className={classes.divider}/>

                <div className={classes.container}>
                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={onReportClick}
                    >
                        {i18n.get('default.error.report')}
                    </Button>

                    <Button
                        className={classes.button}
                        onClick={onHomeClick}
                    >
                        {i18n.get('default.error.recover')}
                    </Button>
                </div>
            </Grid>
        </Grid>
    </React.Fragment>
);

const styles = theme => ({
    layout: {
        width: 'auto',
        minHeight: '100vh',
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    divider: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    icon: {
        color: theme.palette.error.main,
        marginRight: theme.spacing.unit,
        fontSize: 88,
    },
    button: {
        marginLeft: theme.spacing.unit,
    },
});

export default withStyles(styles)(Error);